let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3DkIJ")).then(() => parcelRequire('5ua7I'));